import React, {ReactElement} from "react"

const RecordingIcon = ({className}: {className?: string}): ReactElement => {
	return (
		<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
			<circle cx="6" cy="6" r="6" fill="#FFC2BF" fillOpacity="0.5"/>
			<circle cx="6" cy="6" r="3" fill="#FF1818"/>
		</svg>
	)
}

export default RecordingIcon;
